import posthog from 'posthog-js'

posthog.init('phc_BOngOoosikyamRYjMfKCut52cuapLtP4ttGDODDbNlc', {
  api_host: 'https://eu.i.posthog.com',
  autocapture: false,
  capture_pageview: false,
  person_profiles: 'identified_only',
})

export { posthog }
